@if (selectedFile?.pending) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
@if (profileImagePreload) {
  <img src="{{profileImagePreload}}" [hidden]="true" />
}
<div class="backgroundCoverFull" [style.background]="color" [class.lightMode]="color|isLight" (tap)="doubleTapProfile($event, $safeNavigationMigration(profile?.id))" (press)="pressGuesture()">
  <!-- <div class="stats" fxLayoutAlign="space-evenly start">
  <div>Likes: {{ profile?.metrics?.likes_for_me }}</div>
  <div>Posts: {{ profile?.metrics?.posts }}</div>
  <div>Partners: {{ profile?.metrics?.partners }}</div>
  <div>Kudos: {{ profile?.metrics?.kudos }}</div>
</div> -->
<div [style.background-image]="'url('+ profileImage +')'" (swipeleft)="nextImage(+1)"  (swiperight)="nextImage(-1)" class="backgroundCoverHalf" [class.backgroundIn]="flags?.fadeBackground">
  <div fxlayout="row" class="profileComponent">

    <!-- <mat-icon *ngIf="activity?.meta?.is_new" class="new animate__animated animate__hinge" [style.color]="randomColor()">fiber_new</mat-icon> -->
    <!-- MEMBER IS PREMIUM -->
    <!-- <mat-icon *ngIf="activity?.is_premium" class="new animate__animated" [style.color]="profile?.color">star</mat-icon> -->

    @if (user?.isAuthenticated) {
      <div class="actions">
        @if (activity?.url != null) {
          <button mat-button color="primary" (click)="infoLink()"><mat-icon>info</mat-icon></button>
        }
        @if (flags.enableShare) {
          <button mat-button color="primary" (click)="share();utils.sound('yes')"><mat-icon>shared</mat-icon></button>
        }
        @if (!flags.enableShare) {
          <button [matMenuTriggerFor]="shareMenu" mat-button color="primary"><mat-icon>shared</mat-icon></button>
        }
        <mat-menu #shareMenu="matMenu" [overlapTrigger]="false">
          <div mat-menu-item >
            <button mat-icon-button shareButton="twitter" #twtBtn="shareButton">@if (twtBtn) {
              <fa-icon [icon]="twtBtn.icon" size="lg"></fa-icon>
            }</button>
            <button mat-icon-button shareButton="facebook" #fbBtn="shareButton">@if (fbBtn) {
              <fa-icon [icon]="fbBtn.icon" size="lg"></fa-icon>
            }</button>
            <button mat-icon-button shareButton="email" #emailBtn="shareButton">@if (emailBtn) {
              <fa-icon [icon]="emailBtn.icon" size="lg"></fa-icon>
            }</button>
            <button mat-icon-button shareButton="whatsapp" #whatsappBtn="shareButton">@if (whatsappBtn) {
              <fa-icon [icon]="whatsappBtn.icon" size="lg"></fa-icon>
            }</button>
            <button mat-icon-button shareButton="sms" #smsBtn="shareButton">@if (emailBtn) {
              <fa-icon [icon]="smsBtn.icon" size="lg"></fa-icon>
            }</button>
          </div>
        </mat-menu>
        @if (flags.showAddActivity) {
          <button mat-button color="primary" (click)="addActivity()" [class.zoomBoom]="flags.activityAdded"><mat-icon>add</mat-icon></button>
        }
      </div>
    }
    @if (!user?.isAuthenticated) {
      <div class="actions user">
        @if (activity?.url != null) {
          <button mat-button color="primary" (click)="infoLink()"><mat-icon>info</mat-icon></button>
        }
        @if (flags.enableShare) {
          <button mat-button color="primary" (click)="share();utils.sound('yes')"><mat-icon>shared</mat-icon></button>
        }
      </div>
    }


    <div class="imageNav">
      @for (img of profileImages; track img; let i = $index) {
        @if (profileImages?.length > 1 && i == imageNumber) {
          <mat-icon (click)="nextImage(-1)">face</mat-icon>
        }
        @if (profileImages?.length > 1 && i != imageNumber) {
          <mat-icon class="small" (click)="nextImage(-1)">brightness_1</mat-icon>
        }
      }
    </div>

  </div>
</div>

<div class="info" (swipeleft)="navigate(+1)"  (swiperight)="navigate(-1)">
  <div class="intro">
    <h1> {{ activity?.name }}</h1>
    <br clear="all" />
    <div class="username">#{{activity?.slug}}</div>
  </div>
  <div class="content" [class.lightMode]="color|isLight">

    @if (!activity?.is_alias) {
      <div class="scrollNav">
        @if (groups?.length != 0) {
          <button mat-button (click)="scroll(groupsAnchor)">Groups</button>
        }
        @if (products?.length != 0) {
          <button mat-button (click)="scroll(productsAnchor)">Gear</button>
        }
        @if (videos?.length != 0) {
          <button mat-button (click)="scroll(videosAnchor)">Videos</button>
        }
        @if (flags.memberCount != 0) {
          <button mat-button (click)="scroll(membersAnchor)">Members</button>
        }
        <!-- <button mat-button (click)="scroll(postsAnchor)" *ngIf="postCount?.length != 0">Posts</button> -->
      </div>
    }


    <!-- <button mat-button (click)="goToActivity(primaryActivity)" *ngIf="activity?.is_alias && flags.hasPrimary">Go to {{primaryActivity?.name}}</button> -->

    @if (relatedActivities?.length > 0) {
      <div class="relatedActivities">
        @for (activity of relatedActivities; track activity) {
          <button mat-button [style.background-color]="colorPill(activity)" [class.invertPill]="activity?.is_alias" class="pill" (click)="goToActivity(activity)">{{activity?.name}}</button>
        }
      </div>
    }

    <p class="description">
      {{ activity?.description }}
    </p>

    <div fxlayout="row" class="tags">
      @for (tag of activity?.tags; track tag) {
        <button mat-button class="pill" routerLink="/activities/tag/{{tag}}">{{ tag }}</button>
      }
    </div>
    <br clear="all" />
    <br />
    <div #postsAnchor></div>
    <app-search-posts [slug]="searchStr" (resultCount)="flags.postsCount=$event"></app-search-posts>
    @if (flags.postsCount > 18) {
      <button mat-button [routerLink]="'/search/posts/'+ activity.name" class="more" color="primary">More</button>
    }
    <br clear="all" />

    <!-- <div class="scrollDown">
    <button mat-button onclick="window.scrollTo(0, screen.height)" class="animate__animated animate__shakeY"><mat-icon [style.color]="user?.color">double_arrow</mat-icon></button>
  </div> -->

  <div #groupsAnchor></div>
  @if (groups?.length != 0) {
    <div fxlayout="row" class="groups">
      <div class="resultsHeader on"><mat-icon>groups</mat-icon> Groups</div>
      <ul>
        @for (group of groups; track group) {
          <li>
            <div class="groupName">
              <b>{{ group.name}}</b>
              @if (group?.paid) {
                <mat-icon class="paid">monetization_on</mat-icon>
              }
            </div>
            <div class="groupIcons">
              <a [href]="$safeNavigationMigration(group?.url)" target="_blank"><mat-icon [style.color]="color">website</mat-icon></a>
              @if (group?.location?.place != group?.location?.city+', '+group?.location?.state) {
<a [href]="'https://www.google.com/maps/?q='+$safeNavigationMigration(group?.location?.place)" target="_blank"><mat-icon [style.color]="color">location_on</mat-icon></a>
}
              @if (group?.location?.place == group?.location?.city+', '+group?.location?.state) {
<a [href]="'https://www.google.com/maps/?q='+$safeNavigationMigration(group?.location?.location?.coordinates[1])+','+$safeNavigationMigration(group?.location?.location?.coordinates[0])+'&query_place='+$safeNavigationMigration(group?.name)" target="_blank"><mat-icon [style.color]="color">location_on</mat-icon></a>
}
            </div>
          </li>
}
        </ul>
        <br clear="all" />
      </div>
}
      
      <div #productsAnchor></div>
      @if (products?.length != 0) {
<div fxlayout="row" class="groups">
        <div class="resultsHeader on"><mat-icon>shopping_cart</mat-icon> Gear</div>
        <ul>
          @for (product of products; track product) {
<li><b>{{ product.name}}</b> <a [href]="$safeNavigationMigration(product?.url)" target="_blank"><mat-icon [style.color]="color">website</mat-icon></a>@if (product.description != '') {
<br />
}
            <span>{{ product.description}}</span>
          </li>
}
        </ul>
      </div>
}

      <div #videosAnchor></div>
      @if (videos?.length != 0) {
<div class="videos">
        <div class="resultsHeader on"><mat-icon>videocam</mat-icon> Videos</div>
        @for (video of videos; track video) {
<div>
      
          <div class="title">{{ video.category }}</div>
          <iframe class="videoSquares fadeIn" [src]="video.url|safe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
}
      </div>
}
      
      <div #membersAnchor></div>
      <app-search-users [slug]="searchStr" (resultCount)="flags.memberCount=$event"></app-search-users>
      <!-- <button mat-button [routerLink]="'/search/activities/'+ activity.name" *ngIf="flags.memberCount > 20">More</button> -->
      
      <br clear="all" />

    </div>
  </div>

</div>